import React, { useEffect } from 'react';
import { useVoiceInput } from '../hooks/useVoiceInput'; // ⚠️ новое имя
import { defineMessages, injectIntl } from 'react-intl';

const msg = defineMessages({
  titleIdle:      { id: 'mic_button.title.idle',      defaultMessage: 'Click to record' },
  titleRecording: { id: 'mic_button.title.recording', defaultMessage: 'Recording… Click again to stop' },
  ariaIdle:       { id: 'mic_button.aria.idle',       defaultMessage: 'Click to start recording a voice message' },
  ariaRecording:  { id: 'mic_button.aria.recording',  defaultMessage: 'Voice recording in progress; click again to stop' },
});

function VoiceInputButton({
  disabled,
  tinode,
  intl,
  onTextReady,
  onUploading,
  onRecording,
  onError,ы
}) {
  const {
    isRecording,
    isUploading,
    startRecording,
    stopRecording
  } = useVoiceInput({
    tinode,
    onTextReady,
    onUploading,
    onRecording,
    onError,
    locale: intl.locale
  });

  useEffect(() => { onUploading?.(isUploading); }, [isUploading]);

  if (disabled) return null;

  const handleClick = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const titleMsg = isRecording ? msg.titleRecording : msg.titleIdle;
  const ariaMsg  = isRecording ? msg.ariaRecording  : msg.ariaIdle;

  return (
    <button
      type="button"
      title={intl.formatMessage(titleMsg)}
      aria-label={intl.formatMessage(ariaMsg)}
      className={
        isRecording ? 'mic-btn recording' :
        isUploading ? 'mic-btn uploading' :
        'mic-btn'
      }
      onClick={handleClick}
    >
      <i className="material-icons">mic</i>
    </button>
  );
}

export default injectIntl(VoiceInputButton);
